module.exports = __webpack_public_path__ + "static/swiftlane_mobile-5e4c32274ff91910969ec4049085f0bb.png";